import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { Navbar, Nav, Container } from 'react-bootstrap';

// function Navigation() {
	
class Navigation extends Component {

	constructor() {
    	super();
    	this.state = {
      		showNavigation: "hide"
    	};
    	
	}
	
	toggleNavigation = () => {
		if(this.state.showNavigation === "hide") {
    		this.setState({ showNavigation: "show" });
    	} else {
			this.setState({ showNavigation: "hide" });
		}
	};
	
	showNavigation = () => {
    	this.setState({ showNavigation: "show" });
	};

	hideNavigation = () => {
    	this.setState({ showNavigation: "hide" });
    	
    	window.scrollTo(0, 0);
  	};
  		
	render() {
  	
	  	return (
		    <div className="navigation sj-navigation-pad">
		    	<Navbar fixed="top" collapseOnSelect expand="lg" bg="dark" className="navbar navbar-expand-md navbar-dark bg-dark" >
		      		<Container className="" >
						<NavLink className="navbar-brand" to="/">
							<img
								className="sj-img-icon"
						        src="/logo_sml.png"
						        alt=""
							/>
						</NavLink>
				      	<div className="d-md-none" variant="light" onClick={this.toggleNavigation} >
				      		<img className="sj-navicon" src="/navicon.png" alt="menu" />
				      	</div>
				      	<Navbar.Collapse className={this.state.showNavigation} >
		          			<Nav className="navbar-nav ml-auto">     
			          			<NavLink onClick={this.hideNavigation} className="nav-link" to="/" >
			                 	 Home
			                	</NavLink>	                	
			                	<NavLink onClick={this.hideNavigation} className="nav-link" to="/learn">
				                  Learn
				                </NavLink>	
				                <NavLink onClick={this.hideNavigation} className="nav-link" to="/testimonials">
				                  Testimonials
				                </NavLink>
				                <NavLink onClick={this.hideNavigation} className="nav-link" to="/schedule">
				                  Schedule
				                </NavLink>
				                <NavLink onClick={this.hideNavigation} className="nav-link" to="/contact">
				                  Contact
				                </NavLink>
		                	</Nav>
		        		</Navbar.Collapse>
		      		</Container>
				</Navbar>
		    </div>
	  	);
	}

}

export default Navigation;
